<template>
<div>
  <el-cascader ref="selectArea" v-model="self_area_ids" :options="area_list" @change="selectAreaChange" clearable></el-cascader>
</div>
</template>

<script>
import CommonHelp from "../common/CommonHelp";
import CitySelector from "@/assets/js/citys.js";

export default {
  name: "SelectArea",
  props:{
    pid:{
      type:Number,
      default(){
        return 0;
      }
    },
    level:{
      type:Number,
      default(){
        return 1;
      }
    },
    area_ids:{
      type:String,
      default(){
        return '';
      }
    },
  },
  data(){
    return{
      area_list:[],
      self_area_ids:"",
    }
  },
  created() {
    this.getData();
    this.$nextTick(() => {
    this.initData()
    })
  },
  methods:{
    initData(){
      if(this.area_ids){
        const ids = this.area_ids.split(',');
        // 验证 ID 是否存在于选项中
        const validIds = ids.filter(id => this.idExists(id.trim()));

        if (validIds.length > 0) {
          // 如果只有一个 ID 且是市级，自动补充省级父级
          if (validIds.length === 1) {
            const path = this.findAreaPath(validIds[0]);
            // 如果是省级 ID，尝试获取其第一个市级子节点
            if (path && path.length === 1) {
              const firstChild = this.getFirstChild(path[0]);
              if (firstChild) {
                this.self_area_ids = [path[0], firstChild];
      }else {
                this.self_area_ids = path;
      }
            } else {
              this.self_area_ids = path || validIds;
            }
          } else {
            // 多个 ID 时，使用最后一个 ID 查找完整路径
            const lastId = validIds[validIds.length - 1];
            const path = this.findAreaPath(lastId);
            this.self_area_ids = path || validIds;
          }
        } else {
          this.self_area_ids = '';
        }
      } else {
        this.self_area_ids = '';
      }
    },

    // 根据 ID 查找完整路径
    findAreaPath(targetId, options = this.area_list, path = []) {
      if (!options || options.length === 0) {
        return null;
        }
      for (const option of options) {
        if (option.value === targetId) {
          return [...path, option.value];
        }
        if (option.children) {
          const result = this.findAreaPath(targetId, option.children, [...path, option.value]);
          if (result) {
            return result;
          }
        }
      }
      return null;
    },

    // 获取省级下的第一个市级 ID
    getFirstChild(provinceId) {
      const province = this.area_list.find(p => p.value === provinceId);
      if (province && province.children && province.children.length > 0) {
        return province.children[0].value;
      }
      return null;
    },

    // 验证 ID 是否存在于选项中
    idExists(id, options = this.area_list) {
      const trimmedId = id.trim();
      if (!options || options.length === 0) {
        return false;
      }
      for (const option of options) {
        if (option.value === trimmedId) {
          return true;
        }
        if (option.children && this.idExists(trimmedId, option.children)) {
          return true;
        }
      }
      return false;
    },
    getData(){
      // 使用 citys.js 中的数据替换原有的API调用
      this.area_list = CitySelector.getCascaderData();
    },
    selectAreaChange(item){
      let checkedNodes=this.$refs.selectArea.getCheckedNodes(item)
      let checkedNode=checkedNodes[0]
      let selectData=[];
      (((checkedNode.parent||{}).parent||{}).parent||{}).parent&&selectData.push(checkedNode.parent.parent.parent.parent.data)
      ((checkedNode.parent||{}).parent||{}).parent&&selectData.push(checkedNode.parent.parent.parent.data)
      (checkedNode.parent||{}).parent&&selectData.push(checkedNode.parent.parent.data)
      checkedNode.parent&&selectData.push(checkedNode.parent.data)
      checkedNode.data&&selectData.push(checkedNode.data)
      this.$emit("onAreaChange", {data:checkedNode.data,pathData:selectData,ids:item});
    }
  },
  watch:{
    area_ids(n){
      this.initData()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/components/SelectArea.vue